import {
  OreButton,
  OreHeading,
  OreIconButton,
  OreInput,
  OreStack,
  OreText,
  SvgBin,
  SvgPlus,
} from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useFieldArray } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { Step2Form } from '@/AutoEnrollment/ui/hooks'
import Bill from '@/Shared/ui/assets/tpv-bill.png'

export const Step2TpvsData = (): JSX.Element => {
  const { t } = useTranslation()

  const { register, formState, control } = useFormContext<Step2Form>()
  const { errors } = formState

  const { fields, append, remove } = useFieldArray<Step2Form, 'terminalMid'>({
    control: control,
    name: 'terminalMid',
  })

  return (
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(AutoEnrollmentTranslation.storeTpvsData.title)}
      </OreHeading>

      <OreStack direction="row" space="2xlarge" sameSize>
        <OreStack direction="column" space="large" placeItems="start">
          <OreText size="text-md">
            {t(AutoEnrollmentTranslation.storeTpvsData.description)}
          </OreText>
          <OreStack direction="column" space="xsmall" placeContent="stretch">
            <OreText size="text-md" tone="neutral-600">
              {t(AutoEnrollmentTranslation.storeTpvsData.tpvs.label)}*
            </OreText>
            <OreStack direction="column" space="medium">
              {fields.map((field, index) => (
                <OreStack
                  direction="row"
                  space="small"
                  key={field.id}
                  placeItems="start"
                  placeContent="stretch"
                >
                  <OreInput
                    id={`terminalMid`}
                    {...register(`terminalMid.${index}.value`)}
                    maxLength={50}
                    placeholder={t(
                      AutoEnrollmentTranslation.storeTpvsData.tpvs.placeHolder,
                    )}
                    hasError={
                      errors?.terminalMid &&
                      errors.terminalMid[index]?.value?.message !== undefined
                    }
                    errorMessage={
                      errors?.terminalMid && errors.terminalMid[index]?.value?.message
                    }
                    required
                  />
                  <OreIconButton
                    icon={<SvgBin />}
                    onClick={() => remove(index)}
                    aria-label={t(AutoEnrollmentTranslation.storeTpvsData.tpvs.delete)}
                    disabled={fields.length === 1}
                  />
                </OreStack>
              ))}
            </OreStack>
          </OreStack>
          <OreButton
            category="highlight"
            onClick={() => append({ id: (fields.length + 1).toString(), value: '' })}
            icon={<SvgPlus />}
            iconAlign="right"
          >
            {t(AutoEnrollmentTranslation.storeTpvsData.tpvs.add)}
          </OreButton>
        </OreStack>
        <OreStack direction="column" space="medium">
          <OreText size="text-md">
            {t(AutoEnrollmentTranslation.storeTpvsData.guide.description)}
          </OreText>
          <OreStack placeContent="center">
            <img src={Bill} alt="ticket"></img>
          </OreStack>
        </OreStack>
      </OreStack>
    </OreStack>
  )
}
